import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Button, Dialog, DialogTitle } from "@bookips/sds";
import CouponDownloadItem from "./CouponDownloadItem";
const CouponDownloadDialog = (param)=>{
    let { open , onOpenChange , title , coupons , onDownload , loadingCouponId , className  } = param;
    const handleConfirm = ()=>{
        onOpenChange(false);
    };
    return /*#__PURE__*/ _jsxs(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        classes: {
            contentWrapper: cn("flex flex-col w-[520px] max-w-[calc(100vw-40px)] max-h-[calc(100vh-96px)] max-sm:max-h-[calc(100vh-160px)]", className),
            content: "flex flex-col flex-1 min-h-0 overflow-hidden"
        },
        title: /*#__PURE__*/ _jsx(DialogTitle, {
            title: title,
            className: "shrink-0 px-7 pt-7 max-sm:px-5 max-sm:pt-5"
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-7 max-sm:px-5",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col gap-2",
                    children: coupons.map((coupon)=>/*#__PURE__*/ _jsx(CouponDownloadItem, {
                            coupon: coupon,
                            onDownload: onDownload,
                            isLoading: loadingCouponId === coupon.id
                        }, coupon.id))
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex shrink-0 justify-end px-7 pt-5 pb-7 max-sm:w-full",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "fill",
                    color: "primary",
                    size: "lg",
                    onClick: handleConfirm,
                    className: "max-sm:w-full",
                    children: "확인"
                })
            })
        ]
    });
};
export default CouponDownloadDialog;
